import React from 'react'
import PropTypes from 'prop-types'

import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'

import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import CancelIcon from '@material-ui/icons/Cancel'

export default function DeleteElementDialog (props) {
  const {
    open,
    onClose,
    onDelete
  } = props

  const [showDialog, setShowDialog] = React.useState(false)

  React.useEffect(() => {
  }, [])

  React.useEffect(() => {
    setShowDialog(open)
  }, [open])

  const handleClose = (event, reason) => {
    // don't close by clicking background
    if (reason === 'backdropClick') {
      return
    }

    onClose(event, reason)
  }

  return (
    <Dialog maxWidth="xs" fullWidth={true} open={showDialog} onClose={handleClose}>
      <DialogTitle>Confirm Delete</DialogTitle>
      <DialogContent dividers>
        <Grid container>
          <Grid item xs={12}>
            <Typography>Are you sure you wish to delete this element? If it is a menu or submenu, it will delete ALL Hotkeys beneath it as well.</Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button autoFocus variant="contained" onClick={onDelete} color="primary">
          <CheckCircleIcon />&nbsp;Confirm Delete
        </Button>
        <Button variant="contained" onClick={onClose} color="secondary">
          <CancelIcon />&nbsp;Cancel
        </Button>
      </DialogActions>
    </Dialog>
  )
}

DeleteElementDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onDelete: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
}
